<template>
  <div class="main-pclineaspedidoventa">
    <div>
      <!-- Lineas Pedido Venta Filter -->
      <div class="content-filter-fixed">
        <div class="content-filter padding-half">
          <div>
            <UCDatePicker
              id="1"
              @onchange="ChangedDateQuery"
            />
          </div>
        </div>
        <div class="content-filter-search padding-horizontal-half">
          <UCSearch
            :placeholder="$t('production.dump.orderLineSearch.client.placeholder')"
            :min-length="0"
            :find-on-change="true"
            class="client-search"
            @change="EventClientSelected"
            @search-bar-value-changed="EventClientSelected"
          />
          <UCSearch
            :placeholder="$t('common.references')"
            :min-length="0"
            :find-on-change="true"
            class="reference-search"
            @change="EventReferenceSelected"
            @search-bar-value-changed="EventReferenceSelected"
          />
        </div>
        <div class="content-selection padding-bottom-half">
          <img
            v-if="allSelec"
            :src="icCheckOn"
            alt="iconCheckOn"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <img
            v-else
            :src="icCheckOff"
            alt="iconCheckOff"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <span class="span-selection padding-horizontal">
            {{ $t('common.selectAll') }}
          </span>
        </div>
      </div>

      <UCPreload :show="showPreload" />

      <!-- Lineas Pedido Venta Resultados -->
      <f7-list
        media-list
        class="content-lineas-pedido-venta-list"
      >
        <f7-list-item
          v-for="(item, index) in listaFiltros"
          :key="index"
          :title="GetSalesOrderItemTitle(item)"
          :subtitle="item.LineaPedidoVenta.InfoProducto.Nombre"
          :text="`${item.LineaPedidoVenta.InfoEnvase.Nombre} `"
          @click="OrderLineSelection(item)"
        >
          <template #media>
            <div>
              <img
                v-if="item.Seleccionada === true"
                :src="icCheckOn"
                width="18"
                height="18"
              >
              <img
                v-else
                :src="icCheckOff"
                alt="iconCheckOff"
                width="18"
                height="18"
              >
            </div>
          </template>

          <template #after>
            <div>
              <img
                src="@/static/icons/ic_options.svg"
                width="24"
                height="24"
                alt="iconOption"
                @click="MostrarPopupOpcionesLineaPedido(item)"
              >
            </div>
          </template>

          <template #inner>
            <div class="item-text">
              <span>
                {{ `${$t('common.referenceShort').toUpperCase()} → ${item.LineaPedidoVenta.PedidoVenta.Referencia}` }}
              </span>
            </div>
            <div class="item-text">
              <span>
                {{ `${$t('common.alias')} → ${item.LineaPedidoVenta.PedidoVenta.Cliente.Alias}` }}
              </span>
            </div>
          </template>
          <!-- <pre> {{ item }} </pre> -->
        </f7-list-item>
      </f7-list>
      <!-- ************* BOTON ************** -->
      <div class="content-lineas-pedido-venta-button padding-half">
        <f7-button
          fill
          color="green"
          @click="EventListaSeleccionada()"
        >
          {{ $t('common.confirm') }}
        </f7-button>
      </div>
    </div>
    <!-- ************* CONFIRMAR ************** -->
    <f7-popup
      class="content-lineas-produccion-popup"
      :opened="popupMostrarPopupOpcionesLineaPedido"
      @popup:closed="popupMostrarPopupOpcionesLineaPedido = false"
    >
      <div>
        <TheNavbar
          :style="appTheme"
          :nav-title="$t('production.selectOrderLinePopup.title')"
          :popup-close-btn-enable="true"
        />
        <div class="padding-horizontal padding-top-half">
          <div
            v-for="(item, index) in listaPopup"
            :key="index"
            class="content-lineas-produccion-popup-list"
          >
            <div class="content-lineas-produccion-popup-list__item">
              <div
                class="content-lineas-produccion-popup-list__item"
                :style="{ 'border-bottom': '1px solid var(--his-slate-blue)' }"
              >
                <span class="content-title padding"> {{ GetSalesOrderItemTitleInfo(item) }} </span>
              </div>
              <div class="content-lineas-produccion-popup-list__item">
                <div class="content-lineas-produccion-popup-list__item--title">
                  {{ $t('common.shippingAddress') }}
                </div>
                <div class="content-lineas-produccion-popup-list__item--subtitle">
                  {{ item.DireccionEnvio }}
                </div>
              </div>
              <div class="content-lineas-produccion-popup-list__item">
                <div class="content-lineas-produccion-popup-list__item--title">
                  {{ $t('common.netWeight') }}
                </div>
                <div class="content-lineas-produccion-popup-list__item--subtitle">
                  {{ item.PesoNeto }}
                </div>
              </div>
              <div class="content-lineas-produccion-popup-list__item">
                <div class="content-lineas-produccion-popup-list__item--title">
                  {{ $t('common.grossWeight') }}
                </div>
                <div class="content-lineas-produccion-popup-list__item--subtitle">
                  {{ item.PesoBruto }}
                </div>
              </div>
              <div class="content-lineas-produccion-popup-list__item">
                <div class="content-lineas-produccion-popup-list__item--title">
                  {{ $t('common.packagesPerPallet') }}
                </div>
                <div class="content-lineas-produccion-popup-list__item--subtitle">
                  {{ item.EnvasesPorPalet }}
                </div>
              </div>
              <div class="content-lineas-produccion-popup-list__item">
                <div class="content-lineas-produccion-popup-list__item--title">
                  {{ $t('common.deliveryDate') }}
                </div>
                <div class="content-lineas-produccion-popup-list__item--subtitle">
                  {{ item.FechaEntrega }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </f7-popup>
  </div>
</template>

<script>
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import icCheckOn from '@/static/icons/ic_checked_on.svg';
import icCheckOff from '@/static/icons/ic_checked_off.svg';
import { HiNotification } from '@/js/common/HINotificationSupport';
import UCSearch from '@/components/common/UCSearch.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCLineasPedidoVenta',
  components: {
    UCDatePicker,
    UCSearch,
    UCPreload,
    TheNavbar,
  },

  emits: ['selected'],

  data() {
    return {
      lineaPedidoSeleccionada: [], // tarjeta que seleccionamos
      mainData: [],
      listaFiltros: [], // Lista de los filtros
      listaPopup: [], // lista para mostrar en el Popup
      listaSelect: [],
      optionsSelected: false, // Para solo mostrar el Popup o las Cantidades reservadas por Linea
      popupMostrarPopupOpcionesLineaPedido: false, // Para mostrar el popup
      showPreload: false,
      dateQuery: null,
      statusRequestTypes: {
        SINRESERVA: 0, // No hay ninguina cantidad reservada
        PARCIALMENTERESERVADO: 1, // Hay alguna cantidad reservada pero no la totalidad
        TOTALMENTERESERVADO: 2, // Se ha reservado la cantidad pedida totalmente
        NOTOTALMENTERESERVADO: 3, // Es la unión de Sin Reserva y Parcialmente Reservado.
        TODOS: 4, // Es la unión de Sin Reserva Parcialmente Reservado y Total mente reservado.
      },
      statusRequest: 0,
      icCheckOn,
      icCheckOff,
      allSelec: false,
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.statusRequest = this.statusRequestTypes.TODOS;
      const dateNow = new Date();
      this.dateQuery = `${dateNow.getFullYear()}/${dateNow.getMonth() + 1}/${dateNow.getDate()}`;
      this.GetData();
    },
    /** @public */
    ClearElementSelected() {
      Log(this, this.ClearElementSelected.name);
      this.OrderLineSelection(null);
    },
    GetMainData(filter) {
      Log(this, this.GetMainData.name);
      this.mainData = [];
      this.GETDataSalesOrderLine(JSON.stringify(filter));
    },

    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.listaSelect = this.listaFiltros;

      this.GetData();
    },

    ObtenerLista(listaActualizada) {
      Log(this, this.ObtenerLista.name);

      for (let i = 0; i < listaActualizada.length; i += 1) {
        if (this.listaSelect.length > 0) {
          if (this.listaSelect[i].LineaPedidoVenta.Id === listaActualizada[i].LineaPedidoVenta.Id) {
            this.listaFiltros[i] = this.listaSelect[i];
          } else {
            this.listaFiltros[i].Seleccionada = false;
          }
        }
      }
    },

    ChangedDateQuery(newValue) {
      Log(this, this.ChangedDateQuery.name);
      let stringDate = '';
      if (newValue !== '') {
        stringDate = `${newValue.getFullYear()}/${newValue.getMonth() + 1}/${newValue.getDate()}`;
        this.dateQuery = stringDate;

        this.GetData();
      } else {
        this.listaFiltros = null;
      }
    },

    GetData() {
      Log(this, this.GetData.name);
      const filter = [];
      filter.push({
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      });
      this.GetMainData(filter);
    },

    //* ************************ FILTROS  ************************** */
    EventClientSelected(val) {
      Log(this, this.EventClientSelected.name);
      if (val != null) {
        this.listaFiltros = this.mainData;
        this.FilterClient(val);
      } else {
        this.listaFiltros = null;
      }
    },

    FilterClient(filter) {
      Log(this, this.FilterClient.name);
      if (filter === '') {
        this.listaFiltros = this.mainData;
      } else {
        this.listaFiltros = this.listaFiltros.filter(
          (e) => e.LineaPedidoVenta != null
            && e.LineaPedidoVenta.PedidoVenta.Cliente.Nombre.toString()
              .toLowerCase()
              .includes(filter.toLowerCase()),
        );
      }
    },

    EventReferenceSelected(val) {
      Log(this, this.EventReferenceSelected.name);
      if (val != null) {
        this.listaFiltros = this.mainData;
        this.FilterReferencies(val);
      } else {
        this.listaFiltros = null;
      }
    },

    FilterReferencies(filter) {
      Log(this, this.FilterReferencies.name);
      if (filter === '') {
        this.listaFiltros = this.mainData;
      } else {
        this.listaFiltros = this.listaFiltros.filter(
          (e) => e.LineaPedidoVenta != null
            && e.LineaPedidoVenta.PedidoVenta.Referencia.toString()
              .toLowerCase()
              .includes(filter.toLowerCase()),
        );
      }
    },
    //* **************************************************************************************** */
    ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      this.activityList = this.activityListOrigin;
      this.activityList = this.activityList.filter((e) => e.FechaInicio.includes(newDateValue));
    },

    OrderLineSelection(value) {
      Log(this, this.OrderLineSelection.name);
      if (!this.optionsSelected) {
        // cambia el valor de Seleccionada de la tarjeta seleccionada
        const foundItem = this.listaFiltros.find((f) => f.LineaPedidoVenta.Id === value.LineaPedidoVenta.Id);
        if (foundItem) {
          foundItem.Seleccionada = !foundItem.Seleccionada;
        }

        // comprobamos si están todas seleccionadas o no
        this.allSelec = this.listaFiltros.every((f) => !!f.Seleccionada);
      }
      this.optionsSelected = false;
    },

    EventListaSeleccionada() {
      Log(this, this.EventListaSeleccionada.name);
      const listaSelected = [];
      const tempLista = this.listaFiltros.filter((s) => s.Seleccionada === true);
      tempLista.forEach((e) => {
        listaSelected.push(e.LineaPedidoVenta);
      });

      this.$emit('selected', listaSelected);
      f7.popup.close('.busquedaLineas-popup');
      this.ActualizarDatos();
    },

    //* *************************** POPUP **************************************** */
    MostrarPopupOpcionesLineaPedido(items) {
      Log(this, this.MostrarPopupOpcionesLineaPedido.name);
      this.optionsSelected = true;
      this.lineaPedidoSeleccionada = items;

      const tempExisteciaLinea = this.ObtenerLineaPedido(this.lineaPedidoSeleccionada);

      if (tempExisteciaLinea != null) {
        this.popupMostrarPopupOpcionesLineaPedido = true;
        this.listaPopup = [];

        const tempListaPopup = [];

        tempListaPopup.push({
          Serie: tempExisteciaLinea[0].LineaPedidoVenta.PedidoVenta.Serie,
          Numero: tempExisteciaLinea[0].LineaPedidoVenta.PedidoVenta.Numero,
          Orden: tempExisteciaLinea[0].LineaPedidoVenta.Orden,
          NombreCliente: tempExisteciaLinea[0].LineaPedidoVenta.PedidoVenta.Cliente.Nombre,
          DireccionEnvio: tempExisteciaLinea[0].LineaPedidoVenta.PedidoVenta.DireccionEnvio.Direccion,
          PesoNeto: tempExisteciaLinea[0].LineaPedidoVenta.PesoNeto,
          PesoBruto: tempExisteciaLinea[0].LineaPedidoVenta.PesoBruto,
          EnvasesPorPalet: tempExisteciaLinea[0].LineaPedidoVenta.EnvasesPorPalet,
          FechaEntrega: tempExisteciaLinea[0].LineaPedidoVenta.FechaPrevistaEntrega,
        });

        this.listaPopup = tempListaPopup;
      }
    },

    ObtenerLineaPedido(LineaSeleccionada) {
      Log(this, this.ObtenerLineaPedido.name);
      const tempLineaPedido = this.mainData.filter(
        (t) => t.LineaPedidoVenta.Id === LineaSeleccionada.LineaPedidoVenta.Id,
      );
      if (tempLineaPedido !== undefined) {
        return tempLineaPedido;
      }

      return null;
    },

    AllSelected() {
      Log(this, this.AllSelected.name);
      this.allSelec = !this.allSelec;
      this.listaFiltros.forEach((i) => {
        i.Seleccionada = this.allSelec;
      });
    },

    GetSalesOrderItemTitle(item) {
      return `${item.LineaPedidoVenta.PedidoVenta.Serie} / ${item.LineaPedidoVenta.PedidoVenta.Numero} - `
        + `${item.LineaPedidoVenta.Orden} ${item.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}`;
    },

    GetSalesOrderItemTitleInfo(item) {
      return `${item.Serie} / ${item.Numero} - ${item.Orden} ${item.NombreCliente}`;
    },

    async GETDataSalesOrderLine(filter) {
      Log(this, this.GETDataSalesOrderLine.name);
      this.showPreload = true;
      const result = await ConexionTA.callObtenerLineasPedidoVentaParaPicking(filter);

      this.showPreload = false;

      if (result.Valor) {
        this.mainData = JSON.parse(result.Mensaje);
        this.listaFiltros = this.mainData;
        if (this.listaSelect !== null) {
          this.ObtenerLista(this.listaFiltros);
        }
      } else {
        HiNotification.Toast(result.Mensaje || this.$t('production.info.couldNotQuerySalesOrderInformation'));
      }
    },
  },
};
</script>

<style lang="scss">
.main-pclineaspedidoventa {
  background-color: var(--his-tierra-white);

  --search-input-height: 36px;
  --search-input-color: var(--his-dark-blue);
  --search-input-font-size: 16px;
  --search-input-padding: 0 8px;

  --date-picker-input-height: 36px;
  --date-picker-input-color: var(--his-dark-blue);
  --date-picker-input-font-size: 16px;
  --date-picker-input-padding: 0 8px;

  .content-filter-fixed {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 5;
    background-color: var(--his-tierra-white);
    width: 100%;
  }

  .content-filter {
    display: flex;
    justify-content: center;

    > div {
      width: 100%;
    }
  }

  .content-filter-search {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;

    form {
      background-color: #fff !important;

      > div {
        background-color: transparent !important;
      }

      input {
        background-color: transparent;
      }
    }
  }

  .content-lineas-pedido-venta-list {
    margin-top: 131px;
    height: calc(100vh - 132px - 61px - var(--f7-navbar-height));
    overflow-y: scroll;

    @media (min-width: 630px) {
      margin-top: 140px;
      height: calc(var(--f7-popup-tablet-height) - var(--f7-navbar-height) - 141px - 61px);
    }

    .item-media {
      min-width: 0;
      padding-top: var(--f7-list-item-media-margin);
    }

    .item-title-row {
      align-items: center;

      .item-title {
        color: #172b4d;
        font-size: 14px;
      }

      .item-after {
        height: 24px;
      }
    }

    .item-subtitle {
      color: var(--his-darkgray);
      font-size: 13px;
    }

    .item-text {
      color: var(--his-oliva);
      font-size: 12px;
    }
  }

  .content-selection {
    padding: 8px var(--f7-list-item-padding-horizontal);
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--his-kiwi-pulp);

    .span-selection {
      color: var(--his-darkgray);
      font-size: 14px;
    }
  }

  .content-lineas-pedido-venta-button {
    position: relative;
    bottom: 0;
    border-top: 1px solid var(--his-kiwi-pulp);
  }
}

.content-lineas-produccion-popup {
  background: #fff;

  .content-lineas-produccion-popup-list {
    .content-title {
      align-self: center;
      font-size: 18px;
      color: #172b4d;
    }

    &__item {
      display: flex;
      flex-direction: column;

      &--title {
        color: #172b4d;
        font-size: 18px;
        font-weight: 500;
        margin-top: 15px;
        text-transform: uppercase;
      }

      &--subtitle {
        color: var(--his-darkgray);
        font-size: 14px;
        font-weight: 400;
        margin-top: 5px;
      }
    }
  }
}
</style>
